export default __webpack_public_path__ + "img/sagoo/seq/sagoo4_1500.webp";